import FlightChipGroup from './FlightChipGroup';

export default FlightChipGroup;
